export const bogotaPeriod = () => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit'
  }).formatToParts(new Date())
  const year = parts.find(part => part.type === 'year')?.value
  const month = parts.find(part => part.type === 'month')?.value
  return `${year}-${month}`
}
export const creationPeriod = (value?: string) => {
  if (!value) return ''
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit'
  }).formatToParts(new Date(value))
  return `${parts.find(part => part.type === 'year')?.value}-${parts.find(part => part.type === 'month')?.value}`
}
export const money = (value: number) =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0
  }).format(value)
const statusLabels: Record<string, string> = {
  in_progress: 'En progreso',
  created: 'Pendiente de pago',
  paid: 'Pagada',
  goal_not_met: 'Meta no alcanzada',
  cancelled: 'Cancelada'
}
export const statusLabel = (status: string) => statusLabels[status] || status

export const caseCountLabel = (period: string) =>
  period >= '2026-10' ? 'Casos completos en oficina' : 'Casos registrados'
